/**
 * Input normalization.
 *
 * Applies safe defaults and canonical shapes before plan creation. Keep this
 * pure: no engine knowledge, no validation (validation happens separately).
 */
import type { QueryInput } from './input-types';

export const DEFAULT_LIMIT = 25;

export type NormalizedInput = Omit<QueryInput, 'limit' | 'skip' | 'cursor'> & {
    limit: number;
    skip: number | null;
    cursor: unknown[] | null;
};

export function normalizeInput(input: QueryInput): NormalizedInput {
    return {
        ...input,
        limit: input.limit ?? DEFAULT_LIMIT,
        skip: input.skip ?? null,
        cursor: input.cursor ?? null,
        // TODO: flatten nested same-operator logical filter nodes and other
        // safe canonicalizations here.
    };
}
